export default __webpack_public_path__ + "static/media/radio-selected.c57aca0a.svg";